import React from "react"
import {
  Container,
} from "reactstrap"

const EggType = () => {
  //meta title
  document.title="NattoLabs - Painel Adminitrativo";
  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <h4>Tipo de Ovo - Produção de Ovos</h4>
      </Container>
    </div>
  </React.Fragment>
  );
}

export default EggType;
